import script from "./PaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=4d400adb&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d400adb"]])

export default __exports__